<template>
    <ion-page class="ion-page" id="main">
        <default-header>
            <template v-slot:start>
                <ion-buttons slot="start">
                    <header-menu/>
                </ion-buttons>
            </template>
        </default-header>

        <ion-content fullscreen>
            <flash-messages/>

            <!--            <div v-if="$store.getters.authed && $store.getters.user.covid_agreement_signed_at === null" style="padding: 20px;">-->
            <!--                {{ $t('ncrypt.covid_triage.sign_agreement_to_access') }}-->
            <!--                <br/>-->
            <!--                <br/>-->
            <!--                <ion-button @click="$router.push({name: 'covid-agreement-form'})">-->
            <!--                    {{ $t('ncrypt.covid_triage.visit_agreement_form_button_text') }}-->
            <!--                </ion-button>-->
            <!--            </div>-->

            <div v-if="loading" style="margin: 200px 0; display: flex; justify-content: center;">
                <ion-spinner/>
            </div>

            <ion-grid v-else>
                <covid-passport-dashboard-header/>

                <ion-row>
                    <ion-col size-xs="12">
                        <covid-passport-dashboard
                            :permission-status="permissionStatus"
                            :can-submit-test-result="canSubmitTestResult"
                            :verification-qr-code="verificationQrCode"
                            :bar-code="barCode"
                        />
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
    import DefaultHeader from "../../components/nav/DefaultHeader";
    import FlashMessages from "../../components/ui-elements/FlashMessages";
    import HeaderMenu from "../../components/nav/HeaderMenu";
    import {ApiError} from "@/errors/ApiError";
    import CovidPassportDashboardHeader from "@/components/covid-passport/CovidPassportDashboardHeader";
    import CovidPassportDashboard from "@/components/covid-passport/CovidPassportDashboard";

    export default {
        components: {
            CovidPassportDashboard,
            CovidPassportDashboardHeader,
            HeaderMenu,
            FlashMessages,
            DefaultHeader,
        },
        data() {
            return {
                loading: true,
                permissionStatus: {},
                verificationQrCode: null,
                canSubmitTestResult: false,
                barCode: null,
            }
        },
        methods: {
            retrieveData() {
                this.loading = true;

                this.$http.get('/covid-passport/covid-dashboard-data')
                    .then(async ({data}) => {
                        if (! data) {
                            new ApiError(data);
                            return;
                        }

                        this.permissionStatus = data.permissionStatus;
                        this.verificationQrCode = data.verificationQrCode;
                        this.canSubmitTestResult = data.canSubmitTestResult;
                        this.barCode = data.barCode;
                    })
                    .catch(reason => new ApiError(reason))
                    .finally(() => this.loading = false);
            },
        },
        mounted() {
            if (
                this.$store.getters.authed
                // && this.$store.getters.user.covid_agreement_signed_at !== null
            ) {
                this.retrieveData();
            }
        },
    }
</script>
